export * from './cookies-banner.component';
export * from './cookies-banner.module';
